import { documentReady } from "@sazka/utils/document-ready";
import { useAccordion } from "@sazka/utils/composables/use-accordion";

documentReady(() => {
    const accordions = document.querySelectorAll(".ds-accordion-item");
    const { init } = useAccordion();

    init(accordions);

    if (environment.isEditMode) {
        const obs = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((x) => {
                    const addedEl = x as HTMLElement;
                    if (addedEl.classList?.contains("ds-accordion-item")) {
                        init([addedEl] as any);
                    }

                    const childEls = addedEl?.querySelectorAll(".ds-accordion-item");
                    if (childEls?.length) {
                        init(childEls);
                    }
                });
            });
        });

        obs.observe(document.body, {
            attributes: false,
            childList: true,
            subtree: true,
        });
    }
});
